import { render, staticRenderFns } from "./newsletterB.vue?vue&type=template&id=8a330e8a"
import script from "./newsletterB.vue?vue&type=script&lang=js"
export * from "./newsletterB.vue?vue&type=script&lang=js"
import style0 from "./newsletterB.vue?vue&type=style&index=0&id=8a330e8a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports